import { Pagination } from '@pepper/ui'
import { NUMBER_OF_LIST_PER_PAGE } from '@pepper/utils/src/constant/form/form'

import { DecodedQueryParamFilters, SetQueryParamFilters } from '../FilterParams'
import s from './Footer.module.css'

type FooterProps = {
  total: number
  queryParamFilters: DecodedQueryParamFilters
  setQueryParamFilters: SetQueryParamFilters
}

const Footer = ({
  total,
  queryParamFilters,
  setQueryParamFilters,
}: FooterProps): JSX.Element => {
  const { currentPage, limit: pageSize } = queryParamFilters
  const from = currentPage ? currentPage * pageSize + 1 : 1
  const till =
    currentPage * pageSize + pageSize < total
      ? currentPage * pageSize + pageSize
      : total

  const _itemsRangeText = `Showing ${from} to ${till} of ${total} Items`

  const handlePageChange = (page: number, size?: number) => {
    if (
      queryParamFilters.currentPage === page - 1 ||
      size !== queryParamFilters.limit
    ) {
      setQueryParamFilters({ limit: size, currentPage: 0 })
    } else {
      setQueryParamFilters({ currentPage: page - 1, limit: size })
    }
  }

  return (
    <div className={s.footer}>
      <span>{total > 0 && _itemsRangeText}</span>

      <Pagination
        current={queryParamFilters.currentPage + 1}
        className={s.pagination}
        pageSize={pageSize}
        pageSizeOptions={NUMBER_OF_LIST_PER_PAGE}
        total={total}
        hideOnSinglePage={true}
        size="small"
        simple={true}
        showSizeChanger={true}
        responsive={true}
        showLessItems={true}
        onChange={handlePageChange}
      />
    </div>
  )
}

export default Footer
